import { getCookies } from "cookies-next";
import { IAnalytics } from "./webEvent";

function trackEvent(
  name: string,
  meta: Record<string, string | number | boolean | undefined>,
) {
  if (typeof window !== "undefined") {
    window.analytics.track(name, meta);
  }
}

export function trackEventNext(payload: IAnalytics.TrackPayload) {
  const cookies = getCookies();
  const fbc = cookies["_fbc"];
  const fbp = cookies["_fbp"];
  const ttclid = cookies["ttclid"];
  const ttp = cookies["_ttp"];

  const { event, ...rest } = payload;
  trackEvent(
    event as string,
    { ...rest, fbc, fbp, ttclid, ttp } as IAnalytics.TrackPayload,
  );
}
